// @ts-nocheck

import { type StateType } from '../../../../states';
import { type Selector } from '../../../../types/selectors';
import { type BoomUserState, type BoomUserProgress, type BoomUserBetslips } from '../../reducers/boom';
import { type BoomUserStepProgressState } from '../../reducers/boom';
import { type BoomNotificationState } from '../../types/notification';
import { type BoomStepStatus } from '../../types/steps';
import { BoomUserStatuses, type BoomUserStatus } from '../../types/user';
import { selectBoomState } from '../boom/boomPrimary.selector';

const emptyArray: [] = [];
const emptyObj = {};

type SelectorPropsType = {
  stepId: string;
};

export const selectBoomUserState: Selector<BoomUserState> = (state: StateType) =>
  selectBoomState(state).user ?? emptyObj;

export const selectBoomUserStatus: Selector<BoomUserStatus> = (state: StateType) =>
  selectBoomUserState(state).status ?? BoomUserStatuses.OFF;

export const selectBoomUserProgress: Selector<BoomUserProgress> = (state: StateType) =>
  selectBoomUserState(state).progress ?? emptyObj;

export const selectBoomUserBetslips: Selector<BoomUserBetslips> = (state: StateType) =>
  selectBoomUserState(state).betslips ?? emptyObj;

export const selectBoomUserNotifications: Selector<Array<BoomNotificationState>> = (state: StateType) =>
  selectBoomUserState(state).notifications ?? emptyArray;

export const selectBoomUserProgressEntity: Selector<BoomUserStepProgressState> = (
  state: StateType,
  { stepId }: SelectorPropsType = {},
) => selectBoomUserProgress(state)[stepId] ?? emptyObj;

export const selectBoomUserProgressEntityStatus: Selector<BoomStepStatus | undefined> = (
  state: StateType,
  props: SelectorPropsType = {},
) => selectBoomUserProgressEntity(state, props)?.status;

export const selectBoomUserProgressEntityWonAmount: Selector<number> = (
  state: StateType,
  props: SelectorPropsType = {},
) => selectBoomUserProgressEntity(state, props)?.wonAmount ?? 0;
